import { Navigate } from "react-router";


// Expand on this 
const RequireAuth = ({ children }) => {

    try {
        const userState = localStorage.getItem('role');
        if (userState) {
            const parseUserState = JSON.parse(userState);
            if (parseUserState.hasOwnProperty("token") 
                && parseUserState.hasOwnProperty("id") 
                && parseUserState.hasOwnProperty("role")) {
                return children;
            }
            else {
                localStorage.removeItem('role');
                localStorage.clear();
                sessionStorage.clear();
                return <Navigate to={'/login'} />
            }
        } else {
            localStorage.removeItem('role');
            localStorage.clear();
            sessionStorage.clear();
            return <Navigate to={'/login'} />
        }
    }
    catch(error) {
        return <Navigate to={'/login'} />
    }
    
};

export default RequireAuth;